export default {
    init() {
      $('.facetwp-template .text__documentos').each(function () {
        var post_id = $(this).data('post-id');
        var text = $('.documentos .text__documentos[data-post-id="' + post_id + '"]').text();
        var length = text.length;
        if (length > 250) {
          $(this).text(text.substring(0, 250) + '...');
          $('.view_more_content_btn[data-post-id="' + post_id + '"]').show();
        }
        $('.view_more_content_btn[data-post-id="' + post_id + '"]').click(function (e) {
          e.preventDefault();
          if($(this).text() == 'Ver más') {
            $(this).text('Ver menos');
            $('.text__documentos[data-post-id="' + post_id + '"]').text(text);
          } else {
            $(this).text('Ver más');
            $('.text__documentos[data-post-id="' + post_id + '"]').text(text.substring(0, 250) + '...');
          }
        });
      });
      
			// If class search-results exists, then we are on the search page
			if ($('.search-results').length) {
				// After load page and after ajax load
				$(document).on('facetwp-loaded', function() {
					// if not in top of page, then scroll to top
					if ($(window).scrollTop() > 0) {
						$('html, body').animate({ scrollTop: 0 }, 10);
					}
				});
			}
    },
    finalize() {
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/search.js